module.exports = __webpack_public_path__ + "assets/img/i6.d77996a5.png";